'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOn() {
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOn as $c_Lapp_pages_DocumentsCreatePage$BasedOn };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOn.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOn;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOn() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOn as $h_Lapp_pages_DocumentsCreatePage$BasedOn };
$h_Lapp_pages_DocumentsCreatePage$BasedOn.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On.js.map
